module.exports = __webpack_public_path__ + "img/04_mov.a69808f5.webp";